import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  GetOrganisationsBoardsQueueRequestType,
  GetOrganisationsBoardsQueueResponseType,
} from '../types';

export const getOrganisationsBoardsQueue = async (
  params: GetOrganisationsBoardsQueueRequestType,
) => {
  const url = `/api/v2/organisations/${params.organisationId}/boards/${params.boardId}/queue`;
  const response =
    await apiAuthClient.get<GetOrganisationsBoardsQueueResponseType>(url);

  return response.data;
};
